export default __webpack_public_path__ + "static/media/img1.8e89e6a9.png";